import { defineComponent as _defineComponent } from 'vue'
import UiButton from 'JS/components/UiButton.vue';
import { createPrebuiltHeaderPromoAttributes, createPrebuiltHeaderSubcatPromoAttributes } from '../header-promo-attrs';
import { cssVarsToStyleString } from 'JS/dxp/utilities/css-vars';
import { PrebuiltCategoryHeaderData } from 'JS/dxp/types/widgets/prebuilt-header-widget';


export default /*#__PURE__*/_defineComponent({
  __name: 'HorseCareAndTackHeader',
  props: {
    data: null
  },
  setup(__props: any) {



const title = "Blain's Farm & Fleet Tack Shop";
const subtitle = "Trusted brands and quality products for all your horse tack, feed, grooming, and health needs.";

//Winter Image:
const image = "url('/assets/images/dxp/prebuilt-headers/Horse-Hero.jpg')";

const gaDataAttributes = createPrebuiltHeaderPromoAttributes(title, subtitle);


return { __sfc: true,title, subtitle, image, gaDataAttributes, UiButton, createPrebuiltHeaderSubcatPromoAttributes, cssVarsToStyleString }
}

})